module.exports = __webpack_public_path__ + "img/mulder_256.afa4bd31.png";